function CheckScroll() {
  if(window.scrollY != 0) {
    if(!$('body').hasClass('scrolling')) {
      $('body').addClass('scrolling');
    }
  } else {
    if($('body').hasClass('scrolling')) {
      $('body').removeClass('scrolling');
    }
  }
}

function ToggleMobileMenu() {
  $('html').toggleClass('menu-open');
  $('.hamburger').toggleClass('active');
  $('.mobile-menu').toggleClass('d-none');
}

$(window).scroll(function() {
  CheckScroll();
});

$(document).ready(function() {
  CheckScroll();

  $('.has-dropdown').click(function(e) {
    e.preventDefault();
    $(this).toggleClass('active');
    $(this).next().slideToggle(300);
  })

  $('.footer-block h5').click(function(e) {
    e.preventDefault();
    if(window.matchMedia("(max-width:991px)").matches) {
      $(this).toggleClass('active');
      $(this).next('.footer-block_content').slideToggle(150);
    }
  });

  $('.as-seen-on-slide-container').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots:false,
      centerMode: false,
      arrows: true,
      prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0004/0491/4238/files/img_417301_480x480.png?v=1649339106'/></button>",
      nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0004/0491/4238/files/img_417301_480x480.png?v=1649339106'/></button>",
      infinite:true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        }
       
      ]
    });

  var $sliders = $('.slider');
  if($sliders.length > 0) {
    $('.slider').flickity(SLIDER_OPTIONS);
  }

  var $banners = $('.banner-slider');
  if($banners.length > 0) {
    var $bannerSlides = $('.banner-slider_item');
    var $bannerSlider = $('.banner-slider').flickity({
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      dragThreshold: 10
    });
    
    var $firstSlide = $('.banner-slider_item.is-selected');
    if($firstSlide.data('theme') == "dark") {
      $('header').addClass('dark-mode');
    } else {
      $('header').removeClass('dark-mode');
    }
    
    $bannerSlider.on('change.flickity', function(event, index) {
      var slide = $bannerSlides[index];
      if(slide.dataset.theme != null) {
        if(slide.dataset.theme == "dark") {
          $('header').addClass('dark-mode');
        } else {
          $('header').removeClass('dark-mode');
        }
      }

      // if slide has video
      // pause any playing video
      // play current slide video
    });
  }
});